import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/common/PageHeader";
import { LeadPipeline } from "@/components/leads/LeadPipeline";
import { LeadFilterDialog } from "@/components/leads/LeadFilterDialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CreateLeadSheet } from "@/components/leads/CreateLeadSheet";
import { Search, UserPlus } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LoanStatus } from "@/types";

type OwnershipFilterType = 'all' | 'created' | 'created_shared';

export default function Leads() {
  const [searchQuery, setSearchQuery] = useState("");
  const [ownershipFilter, setOwnershipFilter] = useState<OwnershipFilterType>("all");
  const [createOpen, setCreateOpen] = useState(false);
  const location = useLocation();
  
  // Check for initial filter from navigation state
  const [initialFilter, setInitialFilter] = useState<LoanStatus | "all">("all");
  
  useEffect(() => {
    const state = location.state as { filter?: LoanStatus } | null;
    if (state?.filter) {
      setInitialFilter(state.filter);
      // Clear the state to prevent re-applying filter on subsequent renders
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <AppLayout>
      <div className="p-4 md:p-6 lg:p-8 pt-6 space-y-4 max-w-4xl mx-auto">
        {/* Header with Add Lead Button */}
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1 min-w-0">
            <PageHeader
              title="My Leads"
              subtitle="Manage your loan pipeline"
            />
          </div>
          
          {/* Add Lead Button - Always shows text with icon */}
          <Button
            onClick={() => setCreateOpen(true)}
            className="shrink-0 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white shadow-md hover:shadow-lg transition-all"
            size="sm"
          >
            <UserPlus className="h-4 w-4 mr-2" />
            <span>Add Lead</span>
          </Button>
        </div>

        {/* Search */}
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search: name, phone, city, pincode, pan, email, company, bank..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10"
            />
          </div>
          <LeadFilterDialog value={ownershipFilter} onChange={setOwnershipFilter} />
        </div>

        {/* Pipeline */}
        <LeadPipeline searchQuery={searchQuery} initialFilter={initialFilter} ownershipFilter={ownershipFilter} />
      </div>

      <CreateLeadSheet open={createOpen} onOpenChange={setCreateOpen} />
    </AppLayout>
  );
}